import React, { useState, useEffect } from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import Router from 'next/router';
import { findListingIndex } from '../../../lib/helpers';
import EventEmitter from '../../../lib/eventEmitter';
import style from '../../../styles/sass/components/ListingPreview.module.scss';
import ListingsComponent from './../ListingsComponent';

interface Props {
  dispatch: any;
  initialListing?: any;
  listings: any[];
  router: any;
  token: any;
}

export function ListingsCarousel(props: Props) {
  const { initialListing, listings } = props;
  const [currentIndex, setIndex] = useState<any>(null);

  useEffect(() => {
    if (initialListing) {
      setIndex(findListingIndex(initialListing, 'id', listings));
    }
  }, [initialListing]);

  const _onSlideChange = (index: number) => {
    const currentListing = listings[index];
    setIndex(index);
    EventEmitter.emit('onSlideChange', currentListing);
    const query = props.router.query;
    query.selectedListingId = currentListing.id;
    query.location = `${currentListing.latitude},${currentListing.longitude}`;
    Router.push({
      pathname: '/search',
      query,
    });
  };

  const renderListings = () => {
    return listings.map((listing: any, index: number) => {
      const listingList = () => {
        return listing.photoMediumList.map((photo: any, index: number) => (
          <div className="slick-slide" key={index}>
            <img
              src={photo}
              className={style.slickSlideImage}
              alt={`listing-photo--${index}`}
              style={{
                height: 150,
                width: 338,
                objectFit: 'cover',
              }}
            />
          </div>
        ));
      };

      return (
        <ListingsComponent
          listing={listing}
          listingList={listingList}
          key={index}
          index={index}
          showDelete={true}
        />
      );
    });
  };
  return (
    <React.Fragment>
      <Carousel
        afterSlide={_onSlideChange}
        animation="zoom"
        autoplay={false}
        cellAlign="center"
        cellSpacing={30}
        heightMode="max"
        slideIndex={currentIndex}
        slidesToShow={1}
        slidesToScroll={1}
        withoutControls
      >
        {renderListings()}
      </Carousel>
    </React.Fragment>
  );
}

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(ListingsCarousel);
